const ENVIRONMENT_REGEX = /^(platane\.)(.+\.cardiologs\.com)/;
const LIVE_PR_REGEX = /^pr\d+-platane/;
const LOGIN_REPLACER = 'login';
const CARDIOLOGS_REPLACER = 'cardiologs.com';
const CARDIOLOGS_REGEX = /cardiologs\.com(:\d{1,4})?.*/;
const LOCALHOST_REGEX = /^localhost.*/;

interface Redirect {
  matcher: RegExp;
  replacers: {
    searchValue: RegExp;
    replaceValue: string;
  }[];
}

export function redirectToLoginPortal(
  wLocation = window.location,
  toContinue = true,
) {
  const remoteHost = replaceHost(wLocation.host);
  let redirectUrl = `${wLocation.protocol}//${remoteHost}`;
  if (toContinue) {
    redirectUrl = `${redirectUrl}?continue=${encodeURIComponent(
      wLocation.href,
    )}`;
  }

  if (remoteHost === wLocation.host) {
    throw new Error("Current url doesn't belong to the REDIRECTS");
  }
  wLocation.href = redirectUrl;
}

const REDIRECTS: Redirect[] = [
  {
    matcher: ENVIRONMENT_REGEX,
    replacers: [
      {
        searchValue: ENVIRONMENT_REGEX,
        replaceValue: `${LOGIN_REPLACER}.$2`,
      },
      {
        searchValue: CARDIOLOGS_REGEX,
        replaceValue: `${CARDIOLOGS_REPLACER}$1`,
      },
    ],
  },
  {
    matcher: LIVE_PR_REGEX,
    replacers: [
      {
        searchValue: LIVE_PR_REGEX,
        replaceValue: LOGIN_REPLACER,
      },
      {
        searchValue: CARDIOLOGS_REGEX,
        replaceValue: CARDIOLOGS_REPLACER,
      },
    ],
  },
  {
    matcher: LOCALHOST_REGEX,
    replacers: [
      {
        searchValue: LOCALHOST_REGEX,
        replaceValue: 'localhost:8085',
      },
    ],
  },
];

const replaceHost = (host: string) => {
  let updatedHost = host;
  REDIRECTS.forEach((redirect) => {
    if (host.match(redirect.matcher)) {
      redirect.replacers.forEach((replacer) => {
        updatedHost = updatedHost.replace(
          replacer.searchValue,
          replacer.replaceValue,
        );
      });
    }
  });
  return updatedHost;
};
